import { REGION_LIST } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

export const regionListRequest = () => ({
  url: REGION_LIST,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const createRegion = (regionName) => ({
  url: REGION_LIST,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: {
    regionName,
  },
  service: serviceName.MASTER_MS,
});

export const updateRegion = (regionId, regionName, isActive) => ({
  url: REGION_LIST,
  method: 'put',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: {
    regionId,
    regionName,
    isActive: Number(isActive),
  },
  service: serviceName.MASTER_MS,
});
